import {Injectable} from '@angular/core';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap, catchError } from 'rxjs/operators';
import {SearchApiService} from "./api/search-api.service";
import {FilmApiService} from "./api/film-api.service";
import {ToastService} from "./toaster.service";
import {Version} from "../models/transport.model";

@Injectable({
  providedIn: 'root',
})
export class SearchFilmService {
  constructor(
    private searchService: SearchApiService,
    private filmApiService: FilmApiService,
    private toastService: ToastService,
  ) {}

  searchFilms = (text$: Observable<string>, cookies: string): Observable<any[]> => {
    return text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(term =>
        this.searchService.searchByTerm(cookies, { query_string: term, donnees: 'films' }).pipe(
          map(res => res.items),
          catchError(() => of([]))
        )
      )
    );
  }

  formatter = (film: any) => `${film.nom_film} - ${film.realisateur} - ${film.nom_societe}`;

  searchFilmVersions(cookies: string, idFilm: number): Observable<{ versions: Version[], selectedVersions: string[] }> {
    return this.filmApiService.filmVersions(cookies, idFilm).pipe(
      map(response => {
        const versions: Version[] = response.versions || [];
        const selectedVersions: string[] = versions
          .filter(version => version.checked)
          .map(version => String(version.id_ver));

        return { versions, selectedVersions };
      }),
      catchError(() => {
        this.toastService.showDanger('Error fetching film versions');
        return of({ versions: [], selectedVersions: [] });
      })
    );
  }
}
